import { render, staticRenderFns } from "./addCredit.vue?vue&type=template&id=47b033b7&"
import script from "./addCredit.vue?vue&type=script&lang=js&"
export * from "./addCredit.vue?vue&type=script&lang=js&"
import style0 from "./addCredit.vue?vue&type=style&index=0&id=47b033b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports